<template>
<div>
    <div ref="pieChart" style="width: 100%; height: 400px"></div>
</div>
</template>

<script>
export default {
data() {
    return {
    rawDataUrl: "http://183.175.59.4/devenhancer/rawdata/",
    typeData: [],
    totalTypes: 0, // 新增一个变量用于保存总的 Type 类型数
    };
},
mounted() {
    this.loadData();
},
methods: {
    loadData() {
    this.$axios
        .get(this.rawDataUrl)
        .then((response) => {
        const rawData = response.data;
        this.processData(rawData);
        })
        .catch((error) => {
        console.error(error);
        });
    },
    processData(rawData) {
    // 假设 rawData 是一个带有 'Type' 属性的对象数组
    const typeCount = {};

    rawData.forEach((entry) => {
        const type = entry.Type;
        typeCount[type] = (typeCount[type] || 0) + 1;
    });

    this.typeData = Object.keys(typeCount).map((type) => ({
        name: type,
        value: typeCount[type],
    }));

    // 统计总的 Type 类型数
    this.totalTypes = Object.keys(typeCount).length;

    this.renderPieChart();
    },
    renderPieChart() {
    const pieChart = this.$echarts.init(this.$refs.pieChart);

    const option = {
        title: {
        text: `Type: ${this.totalTypes}`,
        left: 'center',
        top: 80,
        textStyle: {
            color: '#565F69', // 设置标题颜色
        },
        },
        tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        series: [
        {
            name: 'Type',
            type: 'pie',
            radius: ['0%', '80%'],
            center: ['50%', '60%'],
            data: this.typeData,
            label: {
            show: false, // 不显示标签
            formatter: '{b}: {d}%', // 可根据需要调整标签的显示内容
            },
            emphasis: {
            itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
            },
        },
        ],
    };

    pieChart.setOption(option);
    },
},
};
</script>

<style scoped>
/* 如果需要，可以在这里添加样式 */
</style>



// WEBPACK FOOTER //
// src/components/statistics/Rawtablefig4.vue